// @file pricing.js

const $body = $(document.body);

if($body.hasClass("page--education")) {
  let tooltipEdu = require('../components/tooltipEdu').tooltipEdu;
  let $viewPlans = $('.page--education__compare', $body);

  tooltipEdu.init($(".js_education-tool-tip"));

  $('.js_view-plans-button', $body).on('click', (e) => {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $viewPlans.offset().top - 30
    });
  });
}

